import { Injectable } from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {StatusInfo} from '@catfeatures/types';
import {AvodCatalogCreateItem} from '@catmodels/avod-catalog/types';
import {Restangular} from 'ngx-restangular';
import {BehaviorSubject, Observable} from 'rxjs';
import {GenericLinkedResource} from "@catcore/types/base";
import {extractDataFromModel} from "@catcore/utils";

@Injectable()
export class FeatureAvodCatalogService  extends RestHttpService<StatusInfo>  {

  listSubject = new BehaviorSubject([]);

  constructor(service: Restangular) {
    super('feature-avod-catalogs', service);
  }

  /**
   * Initiates the process to create a single AVoDCatalog through the WebAPI
   * @param {any} item
   * @returns {Observable<any>}
   */
  create(item: AvodCatalogCreateItem): Observable<any> {
    return this.add({
      name: item.name,
      feature: item.feature,
      service: item.service._links.self.href,
      removable_media: item.removableMedia,
      throttle: item.throttle,
      low_water_mark: item.lowWaterMark,
      trigger_file: item.triggerFile,
      mode: item.mode,
      track_removes: item.trackRemoves,
      location_id: item.locationId,
      base_u_r_l: item.baseURL,
      root_path: item.rootPath,
      additional_paths: item.additionalPaths,
      playlists_base_path: '',
    })
      .map((createdFeature) => {
        return createdFeature;
      });
  }

  getAvodCatalogs(): Observable<any[]> {
    return this
      .getAll()
      .map((catalogs: any[]) => {
        this.listSubject.next(catalogs);
        return catalogs;
      });
  }

  getPlaylists(avodCatalog): GenericLinkedResource[] {
    const lookupKey = 'playlists';
    return extractDataFromModel<any>(avodCatalog, lookupKey);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/avod-catalog/services/feature-avod-catalog.service.ts